import { pickBy } from 'lodash-unified';
import { isNegative, isObject } from './basicGuards.js';

/**
 * Determine whether a value is nullish
 */

const isNullish = item => item === null || item === undefined;
/**
 * Determine whether a value is not nullish
 */

const nullishFilter = i => i !== null && i !== undefined;
const isNullishOrNegative = val => isNullish(val) || isNegative(val);
/**
 * Throw an error if a nullish value is found in an array. The error can
 * include a list of IDs that were expected to be found, but as different
 * data types will be used in filtering, and we throw as soon as the first
 * missing value is found, there will be no indication of which one(s) were
 * missing.
 *
 * ```
 * .filter(throwingNullishFilter('procedure', procedureIDs))
 * ⬇️
 * Error('Missing at least one procedure (abc123, def456)')
 * ```
 */

const throwingNullishFilter = (entityName = 'value', idsExpectedToBePresent = []) => i => {
  if (isNullish(i)) {
    const idsSuffix = idsExpectedToBePresent.length > 0 ? ` (${idsExpectedToBePresent.join(', ')})` : '';
    throw Error(`Missing at least one ${entityName}${idsSuffix}`);
  }

  return true;
};
/**
 * Remove undefined properties from object
 */

const removeUndefinedValuesFromObj = obj => {
  // Returns null if `obj` is not an object.
  if (!isObject(obj)) return null; // Returns T if `obj` is an object.

  return pickBy(obj, value => value !== undefined);
};

export { isNullish, isNullishOrNegative, nullishFilter, removeUndefinedValuesFromObj, throwingNullishFilter };
